import { selector } from 'recoil';
import { getBookingTemplates, getRegionList, listWarehouse } from '../../repositories/HttpRepository';
import { bookingTemplateFiltersState } from './state';

export const bookingTemplateSelector = selector({
  key: 'selector/booking/templates',
  get: async ({ get }) => {
    const filter = get(bookingTemplateFiltersState);
    const response = await getBookingTemplates(filter);
    return response.data;
  },
});

export const getRegions = selector({
  key: 'selector/regions',
  get: async () => {
    const response = await getRegionList();
    return response.data;
  },
});

export const getWarehouses = selector({
  key: 'selector/warehouses',
  get: async () => {
    const response = await listWarehouse({ size: 9999 });
    return response.data?.items;
  },
});
